module.exports = __webpack_public_path__ + "img/P22.3c5f8055.png";